export default (f?: ((e: any) => void) | undefined) =>
  (e: any): void => {
    e.stopPropagation();
    f && f(e);
  };
